import * as types from './mutations-type'

export const setFROMDAY = ({ commit }, payload) => {
    commit(types.FROMDAY, payload)
}

export const setFROMMONTH = ({ commit }, payload) => {
    commit(types.FROMMONTH, payload)
}

export const setFROMYEAR = ({ commit }, payload) => {
    commit(types.FROMYEAR, payload)
}

export const setTODAY = ({ commit }, payload) => {
    commit(types.TODAY, payload)
}

export const setTOMONTH = ({ commit }, payload) => {
    commit(types.TOMONTH, payload)
}

export const setTOYEAR = ({ commit }, payload) => {
    commit(types.TOYEAR, payload)
}

export const setSHOWEMAILTYPEBLANK = ({ commit }, payload) => {
    commit(types.SHOWEMAILTYPEBLANK, payload)
}

export const setSHOWEMAILTYPEUNUSED = ({ commit }, payload) => {
    commit(types.SHOWEMAILTYPEUNUSED, payload)
}

export const setSHOWEMAILTYPEUSED = ({ commit }, payload) => {
    commit(types.SHOWEMAILTYPEUSED, payload)
}

export const setSHOWEMAILTYPEJUNK = ({ commit }, payload) => {
    commit(types.SHOWEMAILTYPEJUNK, payload)
}

export const setSHOWEMAILTYPECOPY = ({ commit }, payload) => {
    commit(types.SHOWEMAILTYPECOPY, payload)
}

export const setHIDEMARKEDREAD = ({ commit }, payload) => {
    commit(types.HIDEMARKEDREAD, payload)
}

export const setFLAG_C = ({ commit }, payload) => {
    commit(types.FLAG_C, payload)
}

export const setFLAG_EN = ({ commit }, payload) => {
    commit(types.FLAG_EN, payload)
}

export const setFLAG_N = ({ commit }, payload) => {
    commit(types.FLAG_N, payload)
}

export const setFLAG_RL = ({ commit }, payload) => {
    commit(types.FLAG_RL, payload)
}

export const setFLAG_TC = ({ commit }, payload) => {
    commit(types.FLAG_TC, payload)
}

export const setFLAG_AE = ({ commit }, payload) => {
    commit(types.FLAG_AE, payload)
}
export const setFLAG_PO = ({ commit }, payload) => {
    commit(types.FLAG_PO, payload)
}
export const setFLAG_HR = ({ commit }, payload) => {
    commit(types.FLAG_HR, payload)
}
export const setFLAG_RE = ({ commit }, payload) => {
    commit(types.FLAG_RE, payload)
}

export const setFLAG_TL = ({ commit }, payload) => {
    commit(types.FLAG_TL, payload)
}
export const setFLAG_ID = ({ commit }, payload) => {
    commit(types.FLAG_ID, payload)
}
export const setFLAG_PT = ({ commit }, payload) => {
    commit(types.FLAG_PT, payload)
}
export const setFLAG_PN = ({ commit }, payload) => {
    commit(types.FLAG_PN, payload)
}

export const setPANELIST = ({ commit }, payload) => {
    commit(types.PANELIST, payload)
}

export const setSTATE = ({ commit }, payload) => {
    commit(types.STATE, payload)
}

export const setCOUNTRY = ({ commit }, payload) => {
    commit(types.COUNTRY, payload)
}

export const setBUSINESSOWENER = ({ commit }, payload) => {
    commit(types.BUSINESSOWENER, payload)
}

export const setPARTITION = ({ commit }, payload) => {
    commit(types.PARTITION, payload)
}

export const setIsFromSearch = ({ commit }, payload) => {
    commit(types.ISFROMSEARCH, payload)
}

export const resetState = ({ commit }, payload) => {
    commit(types.RESETSTATES, payload)
}

export const setSearchQuery = ({ commit }, payload) => {
    commit(types.SEARCHQUERY, payload)
}

export const setSearchId = ({ commit }, payload) => {
    commit(types.SEARCHID, payload)
}

export const setSearchBy = ({ commit }, payload) => {
    commit(types.SEARCHBY, payload)
}

export const setSearchById = ({commit}, payload) => {
    commit(types.SEARCHBYID, payload)
}


export const setSearchBySubject = ({commit}, payload) => {
    commit(types.SEARCHBYSUBJECT, payload)
}


export const setSearchByBody = ({commit}, payload) => {
    commit(types.SEARCHBYBODY, payload)
}


export const setSearchBySender = ({commit}, payload) => {
    commit(types.SEARCHBYSENDER, payload)
}

export const setPanelistType = ({commit}, payload) => {
    commit(types.PANELIST_TYPE, payload)
}

export const setSearchBySenderName = ({commit}, payload) => {
    commit(types.SEARCHBYSENDERNAME, payload)
}
export const setSearchBySenderEmail = ({commit}, payload) => {
    commit(types.SEARCHBYSENDEREMAIL, payload)
}
